import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/emails/templates",
    name: "email-templates",
    component: () => import("../presentation/pages/EmailTemplates.vue"),
    meta: {
      action: "list",
      subject: "email_template",
      layout: "default",
    },
  },
];
